import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import { useContext, useEffect, useState } from "react";
import Imagic from "../../../components/imagic/imagic";
import { Product } from "../../../models/home-rows";
import { API } from "../../../services/api-services";
import AppContext from "../../../services/app-context-services";
import { trackEvent } from "../../../services/ga-services";
import { ROUTES } from "../../../services/router-services";
import { lastNumberPart, _ } from "../../../services/text-services";
import FetchData from "../fetch-data/fetch-data";
// import styles from "./single-product.module.scss";
import styles from "../products-row/products-row.module.scss";

interface SingleProductProps {
  product: Product;
  series?: boolean;
  title: string;
  isRelatedFile: boolean;
  rowNumber?: number;
  gaTitle?: string;
  relatedResponse?: (id: number) => void;
}


function SingleProduct({
  title,
  gaTitle,
  product,
  isRelatedFile,
  relatedResponse
}: SingleProductProps) {
  const series = false;
  const isSpecialCharacter = false;
  const { isLoggedIn, isIntlUser, setShowLoginPopup } = useContext(AppContext);
  const router = useRouter();
  const [url, setUrl] = useState("");

  useEffect(() => {
    if (!product?.id || isIntlUser) return;
    if (isRelatedFile && !!product.product_id) {
      setUrl(ROUTES.product(product, product.id));
    } else if (product?.id) {
      setUrl(ROUTES.product(product));
    }
  }, [isRelatedFile, product?.product_id, product?.id, product?.name_english]);

  const content = (
    <>
      {series && (
        <div className={`${styles.product__image__wrapper}`}>
          {product?.avatar?.hdpi && (
            <>
              <Imagic
                alt="product-avatar"
                src={product.avatar.hdpi}
                className={`${styles.product__image} ${styles.product__image__copy_2}`}
                style={{ borderRadius: "10px" }}
                //loader={simpleLoader}
              />
              <Imagic
                alt="product-avatar"
                src={product.avatar.hdpi}
                className={`${styles.product__image} ${styles.product__image__copy_1}`}
                style={{ borderRadius: "10px" }}
                //loader={simpleLoader}
              />
            </>
          )}
        </div>
      )}
      <div
        className={`${styles.product__image} ${styles.product__image__wrapper}`}
      >
        {product?.avatar?.hdpi && (
          <Imagic
            src={product.avatar?.hdpi}
            alt={product.name || "product-avatar"}
            layout="fill"
            objectFit="cover"
            style={{ borderRadius: "10px" }}
            //loader={simpleLoader}
          />
        )}
      </div>

      <div
        className={`${styles.product__feature_image} ${styles.product__image__wrapper}`}
      >
        {product?.feature_avatar?.hdpi && (
          <Imagic
            src={product.feature_avatar?.hdpi}
            alt={product.name || "product-avatar"}
            layout="fill"
            objectFit="cover"
            style={{ borderRadius: "10px" }}
            //loader={simpleLoader}
          />
        )}
      </div>

      {series && (
        <div className={`${styles.product__image__wrapper}`}>
          {product?.feature_avatar?.hdpi && (
            <Imagic
              src={product.feature_avatar.hdpi}
              className={`${styles.product__feature_image}
                ${styles.product__feature_image__copy_1}
                ${styles.product__image__copy_2}`}
              style={{ borderRadius: "10px" }}
              width="256"
              height="160"
              alt={product?.name || "product-avatar"}
              //loader={simpleLoader}
            />
          )}
          {product?.feature_avatar?.hdpi && (
            <Imagic
              src={product.feature_avatar.hdpi}
              className={`${styles.product__feature_image} 
                ${styles.product__feature_image__copy_2} 
                ${styles.product__image__copy_1}`}
              style={{ borderRadius: "10px" }}
              width="256"
              height="160"
              alt={product?.name || "product-avatar"}
              //loader={simpleLoader}
            />
          )}
        </div>
      )}

      <div className={`${styles.product__details} desktop`}>
        <div className={`${styles.product__fullname} mb-3`}>
          <span className={`${styles.product__persian_name}`}>
            {product.name}
          </span>
          <span className={`${styles.product__english_name} mr-1`}>
            {product.name_english}
          </span>
        </div>
        <div className={`${styles.product__info}`}>
          <div className={`${styles.product__age} mb-2`}>
            {/* <Image
                  src={`${process.env.NEXT_PUBLIC_FTP_URL}age.png`}
                  alt="رده سنی"
                  className={`img-fluid`}
                  width="80"
                  height="80"
                /> */}
          </div>
          {/* <div className={`product__product_year mb-1`}>
          سال تولید :‌ {_(product.product_year)  }
        </div>
        <div className={`product__language`}>
          زبان :‌ { product.language }
        </div> */}
        </div>

        <div className={`${styles.product__play}`}>
          {/* <Image
                src={`${process.env.NEXT_PUBLIC_FTP_URL}play-button.png`}
                alt="پخش"
                className={`img-fluid`}
                width="80"
                height="80"
              /> */}
        </div>
      </div>
    </>
  );

  return (
    <div
      className={`pt-2 px-1 ${styles.product} ${
        series ? styles.series : ""
      } ${isSpecialCharacter ? styles.product_mobile : ""}`}
      onClick={e => {
        const isTargetProduct = !lastNumberPart(router?.query?.slug?.[2]);
        const gaCategory = !isRelatedFile ? "Home Item" : (router?.query?.slug?.[0] === "game")  ? "Related Game" : "Related Product";
        trackEvent(gaCategory, gaTitle , product?.name);
        if (isRelatedFile && isTargetProduct) relatedResponse(product.id);
        if (isIntlUser) {
          e.preventDefault();
          e.stopPropagation();
          setShowLoginPopup(true);
        }
      }}
    >
      {isIntlUser ? (
        <div className={`${styles.product__main} mx-auto`}>{content}</div>
      ) : (
        <Link href={url} prefetch={false}>
          <a className={`${styles.product__main} mx-auto`}>{content}</a>
        </Link>
      )}
      <div className={`${styles.product__name} mt-2`}>{_(product.name)}</div>
    </div>
  );
}

export default SingleProduct;
